const initialPaso1Seleccion = () => ({
  pacienteFichaId: null,
  pacienteVinculoConfirmado: null,
  osId: null,
  osNombre: '',
  planId: null,
  planNombre: '',
  especialidadId: null,
  especialidadNombre: '',
  profesionalId: null,
  profesionalNombre: '',
  prestadoresIdsCargados: [],
  practica: null,
  pedidoMedicoArchivo: null,
  pedidoMedicoArchivos: [],
  requiereArchivoAdjunto: false,
  descripcionArchivoAdjuntoObligatorio: '',
  pedidoMedicoSeleccionado: null,
  pedEstPId: null,
  practicasAsociadas: [],
  nroAfiliado: '',
  coseguro: '',
})

export default () => ({
  limiteTurnosEntradaValidado: false,
  paso2ResumenLoading: false,
  paso2ResumenFetchEnCurso: false,
  paso2ResumenError: null,
  sedesConTurnoDisponible: [],
  paso2Seleccion: {
    ubicId: null,
    modalidad: null,
  },
  paso1Seleccion: initialPaso1Seleccion(),
  paso3SlotSeleccionado: null,
  /** Cache de calendario mensual por (ubicId, año-mes). Clave: `${ubicId}|${YYYY-MM}`. */
  paso3CalendarioCache: {},
  /** True si la solicitud de calendario para la combinación visible está en curso. */
  paso3CalendarioLoading: false,
  paso3CalendarioError: null,
  paso4Contacto: {
    email: '',
    celular: '',
    telefono: '',
    observaciones: '',
  },
  paso4ContactoListo: false,
})

export { initialPaso1Seleccion }
